import { REHYDRATE } from 'redux-persist';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import api from '../../api';
import { SET_TOKEN } from '../../constants/ActionTypes';
import moment from 'moment-timezone';

const timezone = moment.tz.guess();
moment.tz.setDefault(timezone);

function* rehydrated({ payload }) {
  const token = payload?.auth?.token;
  const companyTimezone = payload?.app?.company?.timezone;

  if (token) {
    api.defaults.headers['Accept'] = 'application/json';
    api.defaults.headers.common['x-timezone'] = companyTimezone || timezone;
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    yield put({ type: SET_TOKEN, payload: token });
  }
}

function* companyUpdated({ payload }) {
  if (payload?.timezone) {
    api.defaults.headers.common['x-timezone'] = payload.timezone;
    moment.tz.setDefault(payload.timezone);
  }
  yield;
}

export function* watchRehydration() {
  yield takeLatest(REHYDRATE, rehydrated);
}

export function* watchCompanyUpdate() {
  yield takeLatest('app/setCompany', companyUpdated);
}

export default function* rootSaga() {
  yield all([fork(watchRehydration), fork(watchCompanyUpdate)]);
}
